import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import get from 'lodash.get';
import { Box, Checkbox, FlexBox, MuiTable, Typography } from '@kis-technologies/kis-ui';
import { ActionOverlay } from 'components/ActionOverlay';
import { selectors as configSelectors, Configuration } from 'services/configuration';
import { DEFAULT_TEXT } from '../strings';
import { useStyles } from '../styled';
import { SeatDetailsOverlayProps } from '../types';

const SeatDetailsOverlay = (props: SeatDetailsOverlayProps) => {
  const { onCancel, onConfirm, seatClickedMessage } = props;
  const { t } = useTranslation();

  const configuration = useSelector(configSelectors.selectConfiguration) as Configuration;

  const primaryPalette = get(configuration, 'configuration.globalSettings.palette.primary');

  const [isSelected, setIsSelected] = useState(false);

  const classes = useStyles();

  const renderTitle = () => {
    return (
      <FlexBox direction="column" align="center">
        <Typography variant="h4">
          {t('commonText.section')} {seatClickedMessage.section.label}
        </Typography>
        <Typography variant="h4">
          {t('commonText.row')} {seatClickedMessage.seat.seatRow} &middot; {t('commonText.seat')}{' '}
          {seatClickedMessage.seat.seatNumber}
        </Typography>
      </FlexBox>
    );
  };

  const renderDescription = () => {
    return (
      <Box flexOverride="none" padding="0 3" width="900px">
        <MuiTable.TableContainer id="seatDetailsTable" className={classes.seatDetailsTableContainer}>
          <MuiTable.Table className={classes.seatDetailsTable} stickyHeader sx={{ borderCollapse: 'collapse' }}>
            <MuiTable.TableRow
              className={classes.seatDetailsTableRow}
              sx={{ border: `3px solid ${isSelected ? primaryPalette : 'transparent'}` }}
              onClick={() => setIsSelected(!isSelected)}
            >
              <MuiTable.TableCell className={`${classes.seatDetailsTableCell} ${classes.seatDetailsCheckboxTableCell}`}>
                <FlexBox justify="center">
                  <Checkbox
                    size="medium"
                    checked={isSelected}
                    // onChange={(e, checked) => setIsSelected(checked)}
                    // data-testid={`remove-checkbox-${idx}`}
                  />
                </FlexBox>
              </MuiTable.TableCell>
              <MuiTable.TableCell className={classes.seatDetailsTableCell}>
                <Typography fontSize={24} fontWeight={600}>
                  {'Standard Ticket'}
                </Typography>
              </MuiTable.TableCell>
              <MuiTable.TableCell className={`${classes.seatDetailsTableCell}`}>
                <Typography fontSize={24} fontWeight={600} align="right">
                  {'$50.00'}
                  {/* {showCartItemsPrice && item.unitPrice ? formatCurrency(item.unitPrice, {}, languageSettings) : null} */}
                </Typography>
              </MuiTable.TableCell>
            </MuiTable.TableRow>
          </MuiTable.Table>
        </MuiTable.TableContainer>
      </Box>
    );
  };

  return (
    <ActionOverlay
      title={renderTitle()}
      description={renderDescription()}
      cancelText={t('commonText.cancel')}
      confirmText={DEFAULT_TEXT.addSeat}
      onCancel={() => onCancel()}
      onConfirm={isSelected ? () => onConfirm() : undefined}
      height={500}
      style={{ background: 'rgba(255,255,255,0.95)' }}
    />
  );
};

export default SeatDetailsOverlay;
